import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CreateNewPaymentMethodPage } from './create-new-payment-method.page';

const routes: Routes = [
  {
    path: '',
    component: CreateNewPaymentMethodPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreateNewPaymentMethodPageRoutingModule {}
